enum WorkspaceProjectDatasetTransactionStatus {
  failed = 'failed',
  pending = 'pending',
  success = 'success',
}

export default WorkspaceProjectDatasetTransactionStatus
